import HeaderMono from "../ui/HeaderMono";
import { about } from "../../content";

export default function About({ sectionTint }) {
  return (
    <section id="about" className={`border-t border-white/5 ${sectionTint}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <HeaderMono>{about.heading}</HeaderMono>
        <div className="space-y-4">
          {about.paragraphs.map((p, i) => (
            <p key={i} className="text-slate-300 leading-relaxed">{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
